import { css, CSSObject } from '@emotion/react'

export const resizeContainer = css({
  '&.is-resizing': {
    '.node-asset > [data-node-view-wrapper], .texteditor-asset-image': {
      /* eslint-disable opal-rules/prefer-logical-properties */
      width: 'inherit',
      height: 'inherit',
      /* eslint-enable opal-rules/prefer-logical-properties */
    },
  },

  // Hide resize handles in readonly/viewing mode
  '[contenteditable="false"] &': {
    '[data-resize-handle]': {
      display: 'none !important',
    },
  },
})

export const nodeView = (nodeType: string) =>
  css({
    display: nodeType === 'asset' ? 'inline-block' : 'block',

    '&:first-of-type div[data-node-view-wrapper]': {
      paddingInlineStart: 0,
    },

    '&:not(.ProseMirror-selectednode) ~ [data-resize-handle]': {
      display: 'none',
    },
  })

export const placeholder: Record<'asset' | 'resource', CSSObject> = {
  asset: {
    width: 'calc(160px + 24px)',
    height: 'calc(160px + 12px)',
    padding: '6px 12px',
    borderRadius: '12px',

    '> div': {
      borderRadius: 'inherit',
    },
  },
  resource: {
    width: '250px',
    height: 'calc(36px + 12px)',
    padding: '6px 0',
    display: 'inline-block',

    '> div': {
      borderRadius: '4px',
    },
  },
}

export const placeholderBg: CSSObject = {
  cursor: 'grab',
  backgroundColor: '#eee',
  userSelect: 'none',
  inlineSize: '100%',
  blockSize: '100%',
}
